import { useDispatch } from 'react-redux';
import RtcClient from '@/lib/RtcClient';
import { stopShare } from '@/store/slices/room';
import styles from './index.module.less';
import TeaClient from '@/lib/TeaClient';

function StopShareBtn() {
  const dispatch = useDispatch();

  const handleStopShare = async () => {
    RtcClient.sendServerMessage('videocallEndShareScreen');
    await RtcClient.stopScreenCapture();
    TeaClient.reportStopScreenSharing();
    dispatch(stopShare());
  };

  return (
    <div className={styles.StopShareWrapper}>
      <div className={styles.stopSperature} />
      <div className={styles.stop} onClick={handleStopShare}>
        结束共享
      </div>
    </div>
  );
}

export default StopShareBtn;
